module.exports = __webpack_public_path__ + "media/images/flags/4x3/npl-216a8d2a51c4db3f02224b4b245255f9.svg";